import React from "react"
import { Loader2 } from "lucide-react"

interface Props {
  Title: string
  Value: string | null
  Metric?: string
  Description?: string
  loading?: boolean
}

const SimpleMetric: React.FC<Props> = ({
  Title,
  Value,
  Metric,
  Description,
  loading = false,
}) => {
  return (
    <div className="border border-gray-300 rounded-lg p-4 bg-white dark:bg-gray-900 dark:border-gray-700">
      <h3 className="mb-4 text-lg font-semibold text-gray-900 dark:text-gray-100">{Title}</h3>

      {loading ? (
        <div className="flex flex-col items-center justify-center py-8">
          <Loader2 className="animate-spin h-8 w-8 text-blue-500 dark:text-blue-400 mb-2" />
          <span className="text-gray-700 dark:text-gray-300">Loading...</span>
        </div>
      ) : (
        <>
          <div className="text-4xl font-semibold mb-2 text-gray-900 dark:text-gray-100">
            {Value ?? "--"}{" "}
            {Value && Metric && (
              <span className="text-lg font-normal text-gray-700 dark:text-gray-300">{Metric}</span>
            )}
          </div>

          {Description && (
            <div className="text-sm text-gray-500 dark:text-gray-400">{Description}</div>
          )}
        </>
      )}
    </div>
  )
}

export default SimpleMetric